import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { formsV2 as Forms } from '@breezeway/brzw-components';

const SelectFormik = props => {
  const {
    additionalProps,
    className,
    clearable,
    creatable,
    disabled,
    error,
    field,
    form,
    id,
    label,
    onChange,
    options,
    placeholder,
    required,
    searchable,
    size,
  } = props;
  const { errors, submitCount, touched, setFieldValue } = form;
  const withError =
    ((touched[field.name] || submitCount > 0) && !_.isEmpty(errors[field.name])) || error;

  const errorText = withError ? errors[field.name] : null;

  const onSelect = value => {
    const canSetValue = (!clearable && !_.isEmpty(value)) || clearable;

    if (canSetValue) {
      setFieldValue(field.name, value);
    }

    if (_.isFunction(onChange)) {
      onChange(value);
    }
  };

  return (
    <Forms.Select
      additionalSubText={errorText}
      className={className}
      clearable={clearable}
      creatable={creatable}
      disabled={disabled}
      iconAfter={withError && 'info-outline'}
      id={id || field.name}
      isRequired={required}
      labelText={label}
      onSelect={onSelect}
      options={options}
      placeholderText={placeholder}
      searchable={searchable}
      size={size}
      value={field.value}
      withError={withError}
      {...additionalProps}
    />
  );
};

SelectFormik.propTypes = {
  additionalProps: PropTypes.shape({}),
  className: PropTypes.string,
  clearable: PropTypes.bool,
  creatable: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  field: PropTypes.shape({}),
  form: PropTypes.shape({}),
  id: PropTypes.string,
  input: PropTypes.shape({ onChange: PropTypes.func }),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  meta: PropTypes.shape({}),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  size: PropTypes.string,
};

SelectFormik.defaultProps = {
  additionalProps: {},
  className: '',
  clearable: true,
  creatable: false,
  disabled: false,
  error: false,
  onChange: null,
  options: null,
  placeholder: '',
  required: false,
  searchable: false,
};

export default SelectFormik;
